// @flow
import LogRocket from 'logrocket';
import { LOGIN_SUCCESS } from "../actions/actionTypes";

class LoggerWrapper {
    static initialize() {
        if (!process.env.REACT_APP_LOG_ROCKET_APP_ID) {
            return;
        }

        LogRocket.init(`${process.env.REACT_APP_LOG_ROCKET_APP_ID}`, {
            network: {
                requestSanitizer: (request) => {
                    // Do not log jwt
                    if (request.headers.Authorization) {
                        request.headers.Authorization = '*********';
                    }

                    return request;
                },
                responseSanitizer: (response) => {
                    if (response.body) {
                        const body = JSON.parse(response.body);
                        if (body['access_token']) {
                            body['access_token'] = '********';
                            response.body = body;
                        }
                    }

                    return response;
                }
            }
        });
    }

    static startNewSesstion() {
        LogRocket.startNewSession();
    }

    static identify(userName: string, firstName: string, lastName: string) {
        LogRocket.identify(userName, {
            email: userName,
            name: `${firstName} ${lastName}`
        });
    }

    static reduxMiddleware() {
        const reduxLoggingOptions = {
            stateSanitizer(state) {
                return {
                    ...state,
                    auth: {
                        ...state.auth,
                        accessToken: undefined,
                    }
                }
            },
            actionSanitizer(action) {
                if (action.type === LOGIN_SUCCESS) {
                    return {
                        ...action,
                        accessToken: undefined,
                    }
                }
                return action;
            }
        };
        return LogRocket.reduxMiddleware(reduxLoggingOptions);
    }
}

export default LoggerWrapper;